import script from "./OrderType.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderType.vue?vue&type=script&setup=true&lang=js"

import "./OrderType.vue?vue&type=style&index=0&id=25f38dc7&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25f38dc7"]])

export default __exports__